import { Injectable } from '@angular/core';
import { ModalConfig } from '../models/modal-config';
import { Subject } from 'rxjs';

interface ModalRequest {
  config: ModalConfig;
  resolve: (value: any) => void;
}

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private readonly _requests = new Subject<ModalRequest>();
  requests$ = this._requests.asObservable();

  open(config: ModalConfig): Promise<any> {
    return new Promise((resolve) => {
      this._requests.next({ config, resolve });
    });
  }
}
